module.exports = __webpack_public_path__ + "app-static/img/icon_daitou.001d63b2.png";